export default "__VITE_ASSET__CT$x0$oy__"